import VolumeAccounting from './VolumeAccounting';

export default VolumeAccounting;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/Inventory/VolumeAccounting/index.tsx